var map = {
	"./Embassy.png": 1071,
	"./HoABL.png": 2029,
	"./adani.png": 7323,
	"./adaniTransparent.png": 6415,
	"./adarshGroups.png": 4594,
	"./assetz.jpg": 1875,
	"./azimPremji.png": 8070,
	"./bagmane.jpg": 5587,
	"./birla.png": 8155,
	"./brigade.png": 5781,
	"./brigadeGroup.png": 1998,
	"./brookfield.png": 6609,
	"./brookfieldProperties.jpg": 7699,
	"./cbre.png": 5418,
	"./century.png": 2278,
	"./client2.png": 7820,
	"./dlf.png": 1575,
	"./dynacon.jpg": 1223,
	"./e2eRail.png": 1405,
	"./elan.png": 3807,
	"./eldeco.png": 7299,
	"./emaar.png": 4037,
	"./embassyReit.png": 8868,
	"./experion.png": 1079,
	"./featherLiteDevelopers.png": 6623,
	"./gera.png": 9266,
	"./gleeds.png": 8160,
	"./godrej.png": 2977,
	"./godrejPropertiesWhite.png": 6439,
	"./godrejproperties.png": 8925,
	"./isprava.jpg": 7164,
	"./jll.png": 6423,
	"./jllWhite.png": 3870,
	"./k2kInfra.jpg": 5850,
	"./kec.jpg": 3975,
	"./koltePatil.png": 6558,
	"./l&tRealty.jpg": 2818,
	"./lodha.png": 6620,
	"./lodhaTransparent.png": 6710,
	"./lt.jpg": 8178,
	"./maia.png": 8882,
	"./marathon.png": 3674,
	"./maxEstates.png": 3859,
	"./ncc.png": 3233,
	"./neoLiv.jpg": 6277,
	"./nkg.jpg": 2911,
	"./oberoiRealty.png": 5541,
	"./piramalRealty.png": 9041,
	"./piramalRealtyTransparent.png": 6979,
	"./prestigeGroup.png": 5385,
	"./prithu5.jpg": 3259,
	"./quess.jpg": 657,
	"./rmz.png": 7372,
	"./royalorchid.png": 3777,
	"./runwalGroup.png": 5896,
	"./saifee.png": 2272,
	"./saifeeBurhani.jpg": 9807,
	"./savills.png": 8943,
	"./shapoorjiPallonji.png": 3302,
	"./shapoorjiPallonjiRealEstate.png": 255,
	"./shbha2.jpg": 1481,
	"./shobhaprojects.jpg": 7528,
	"./shriramProperties.png": 9938,
	"./starworth.png": 4184,
	"./sunPharma.png": 3757,
	"./suncityProjects.jpg": 5290,
	"./swadeshiCivilInfra.png": 3394,
	"./tataProjects.png": 5652,
	"./tataprojects.jpg": 1493,
	"./thehouseofabhinandan.png": 726,
	"./transrail.png": 7612,
	"./tvs.png": 598,
	"./vensa.jpg": 7695,
	"./victoryone2.jpg": 4822
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6950;